import React from "react"

import PricePage from "../../components/CatalogCeramic/PricePage"
import { ceramicCars } from "../../components/CatalogCeramic/data"

const KatalizatorPage = () => <PricePage data={ceramicCars[3]} />

export default KatalizatorPage
